import React from "react";
import "./index.scss";

import Logo from "../../../assets/icons/ft-logo.svg";

import Socials from "common/Socials";
// import JoinOurMailingForm from '../JoinOurMailingForm'

const JoinMailing = (props) => {
  return (
    <div className="joinMailing">
      {/* <JoinOurMailingForm /> */}

      <div className="content">
        <div className="showLogo">
          <img alt="" src={Logo} />

          <Socials theme="dark" />
        </div>

        <div className="contentBot">
          <div className="melbour">
            {/* <h5>Belize</h5> */}
            <p>123 Barrack Road, Belize City, Belize</p>
          </div>

          <div className="mailContact">
            <address>
              <a href="mailto:contact@precog.finance">contact@precog.finance</a>
            </address>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinMailing;
